import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReplaySubject } from 'rxjs';
import { FinalPackageService } from './../../service/final-package.service';

@Component({
    selector: 'app-final-package',
    templateUrl: './final-package.component.html',
    styleUrls: ['./final-package.component.scss'],
    standalone: false // NOSONAR
})
export class FinalPackageComponent {

  ngOnInit(): void { // NOSONAR
    this.loadPeriodsData();
    this.loadDomicilesData();


  }

  @ViewChild('singleSelect') singleSelect: MatSelect;

  @ViewChild('domicileSelect') domicileSelect: MatSelect;

  public periodSearch: FormControl = new FormControl();
  public filteredPeriods: ReplaySubject<any> = new ReplaySubject<any>(1);

  public domicileSearch: FormControl = new FormControl();
  public filteredDomiciles: ReplaySubject<any> = new ReplaySubject<any>(1);

  enableError: boolean = false;
  enableSubmit: boolean = false;
  domicileErrorMsg: string = "";
  periodErrorMsg: string = "";
  periodLst: any = [];
  domicilesLst: any = [];
  _onDestroy: '';

  successMessage = '';
  errorMessage = '';
  periodChoosen = '';
  domicileChoosen = '';

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly finalPkgService: FinalPackageService, private readonly cdref: ChangeDetectorRef) { }


  ngAfterContentChecked() { // NOSONAR
    this.cdref.detectChanges();
  }

  view() {
    console.info("Period " + this.periodChoosen);
    console.info("Domicile: " + this.domicileChoosen);

    alert(this.periodChoosen);

  }

  protected filterPeriods() {
    if (!this.periodLst) {
      return;
    }
    // get the search keyword
    let search = this.periodSearch.value;
    if (!search) {
      this.filteredPeriods.next(this.periodLst.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPeriods.next(
      this.periodLst.filter(period => period.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterDomiciles() {
    if (!this.domicilesLst) {
      return;
    }
    // get the search keyword
    let search = this.domicileSearch.value;
    if (!search) {
      this.filteredDomiciles.next(this.domicilesLst.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDomiciles.next(
      this.domicilesLst.filter(domicile => domicile.toLowerCase().indexOf(search) > -1)
    );
  }

  validateInput() {
    console.info("Period " + this.periodChoosen);
    console.info("Domicile: " + this.domicileChoosen);


    if (this.periodChoosen == null || this.periodChoosen == '' || this.periodChoosen == undefined) {  // NOSONAR
      this.periodErrorMsg = 'Period is Required';
    } else {
      this.periodErrorMsg = '';
    }

    if (this.domicileChoosen == null || this.domicileChoosen == undefined) {  // NOSONAR
      this.domicileErrorMsg = 'Enter Route Date';
    } else {
      this.domicileErrorMsg = '';
    }
    this.enableError = this.periodErrorMsg  !=  "" ? true : false; // NOSONAR
    this.enableError = this.domicileErrorMsg  !=  "" ? true : false; // NOSONAR
    if (this.enableError) {
      this.enableSubmit = false;
    } else {
      this.enableSubmit = true;
    }
  }

  public loadPeriodsData() {
    this.ngxUiLoaderService.start("loader-01");
    this.periodLst = [];

    this.finalPkgService.getPeriodsData().subscribe(result => {
      console.info("calling getPeriodsData");
      if (result?.length > 0) {
        localStorage.setItem('Period Data', JSON.stringify(result));
        this.periodLst = result;
        this.filteredPeriods.next(this.periodLst.slice());

        // listen for search field value changes
        this.periodSearch.valueChanges
          .subscribe(() => {
            this.filterPeriods();
          });
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  };

  public loadDomicilesData() {
    this.ngxUiLoaderService.start("loader-01");
    this.domicilesLst = [];

    this.finalPkgService.getDomicilesData().subscribe(result => {
      console.info("calling getDomicilesData");
      if (result?.length > 0) {
        localStorage.setItem('Domicile Data', JSON.stringify(result));
        this.domicilesLst = result;
        this.filteredDomiciles.next(this.domicilesLst.slice());

        // listen for search field value changes
        this.domicileSearch.valueChanges
          .subscribe(() => {
            this.filterDomiciles();
          });
      }
      else {
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  };

}

